import Env from './Env'
//百分比
function ToolPercent(num) {
    var str = Number(num * 100).toFixed(1);
    str += "%";
    return str;
}
//评论跳转
function toView(pid,fid,cid){
    let linkhost='';
    if (Env.isTest) {  
        linkhost='//t.m.3839.com/review/'
    } else{
        linkhost='//m.3839.com/review/'         
    }

    //渠道
    let {sem_qd,sem_version,apk_version,channel_id}=window.sem_qd_info
    let qdStr=''
    if(sem_qd!==undefined||apk_version!==undefined){
        if(channel_id!=''){
            qdStr=`&sem_qd=${sem_qd}&sem_version=${sem_version}&apk_vserion=${apk_version}&channel_id=${channel_id}`
        }else{
            qdStr=`&sem_qd=${sem_qd}&sem_version=${sem_version}&apk_vserion=${apk_version}`
        }
    }
    window.open(linkhost+'?pid='+pid+'&fid='+fid+'&cid='+cid+qdStr);
} 
//
function getComLineHeight() {
    return document.body.clientWidth / 750 * 42;
}
//Dom操作
function hasClass(elements, cName) {
    return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
}
function addClass(elements, cName) {
    if (!hasClass(elements, cName)) {
        elements.className += " " + cName;
    }
}
function removeClass(elements, cName) {
    if (hasClass(elements, cName)) {
        elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
    }
}
function siblings(elem) {
    var a = [];
    var b = elem.parentNode.children;
    for (var i = 0; i < b.length; i++) {
        if (b[i] !== elem) {
            a.push(b[i]);
        }
    }
    return a;
}
function playTime(val){
    let nh=60*60;
    let nm=60;
    if(val>=nh){
        let th=parseInt(val/nh)
        let tm=parseInt((val-th*nh)/nm)
        return th+'小时'+(tm==0?'':tm+'分钟')
    }else if(val>=nm){
        let tm=parseInt(val/nm)
        let ts=val-tm*nm
        return tm+'分钟'+(ts==0?'':ts+'秒')
    }else{
        return val+'秒'
    }
}

function cutstr(str, len) {
    var str_length = 0;
    var str_len = str.length;
    var str_cut = '';
    for (var i = 0; i < str_len; i++) {
        let a = str.charAt(i);
        str_length++;
        if (escape(a).length > 4) {
            //中文字符的长度经编码之后大于4  
            str_length++;
        } //concat()方法用于连接两个或多个数组
        str_cut = str_cut.concat(a);
        if (str_length >= len) {
            str_cut = str_cut.concat("");
            return str_cut;
        }
    }
    //如果给定字符串小于指定长度，则返回源字符串；  
    if (str_length < len) {
        return str;
    }
}

export default {
    ToolPercent,
    toView,
    getComLineHeight,
    addClass,
    removeClass,
    hasClass,
    siblings,
    playTime,
    cutstr
}